<template>
  <div>
    <nav-bar class="home-nav">
      <div slot="left" @click="onClickLeft">返回</div>
      <div slot="center">俱乐部列表({{ countClub }})</div>
    </nav-bar>


    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in clubs" :key="item.id">
          <van-cell :border="false" :label="'负责教师:'+item.tName"
                    :title="item.title" value="<--">
            <van-button square type="warning" @click="SelectClub(item)" text="选择"/>
            <van-button square type="primary" @click="lookClub(item.id)" text="详情"/>
          </van-cell>
        </van-swipe-cell>

      </van-list>
    </van-pull-refresh>

    <van-action-sheet v-model="descriptionShow" :title="this.title+' 俱乐部介绍'">
      <van-notice-bar left-icon="volume-o">
        选课开始时间' {{ new Date(parseInt(this.startTime)).toLocaleString() }}
      </van-notice-bar>

      <van-notice-bar wrapable color="#1989fa" background="#ecf9ff" left-icon="info-o">
        <p>俱乐部最大人数： {{ this.maxp }}人,</p>
        <p>俱乐部位置：{{ this.location }}</p>
      </van-notice-bar>

      <div style="  padding: 16px 16px 70px;font-size: 18px;font-family: 楷体;">{{ this.description }}</div>


    </van-action-sheet>
  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar";
import {getClubList, SelectClub, GetClubCountById, GetClubDetailById} from "@/network/club";
import {GetClubInfo} from "@/network/student";
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Field,
  Popup,
  Picker,
  Cell,
  Button,
  PullRefresh,
  List,
  SwipeCell,
  Toast, Dialog,
  ActionSheet,
  NoticeBar
} from 'vant';


Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Cell);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(SwipeCell);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(ActionSheet);
Vue.use(NoticeBar);

export default {
  name: "ClubSelectList",
  components: {
    NavBar
  },
  data() {
    return {
      clubs: [],


      //refresh
      refreshing: false,
      loading: false,
      finished: true,

      //ActionSheet
      descriptionShow: false,
      title: "",
      location: "",
      startTime: "",
      description: "",

      //Club的数量
      countClub: 0,

      //根据club id得出的这个club的人数
      // ClubPeopleCount: 0,
      maxp: 0
    };
  },
  activated() {
    this.getClubList();
    GetClubInfo().then(res => {
      if (res.select) {
        this.$router.replace("/ClubSelect/ClubDetail");
      }
    })
  },
  methods: {
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.clubs = [];
      // 重新加载数据
      this.getClubList();
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
      // setTimeout(() => {
      //
      //   this.isLoading = false;
      // }, 1000);
    },
    getClubList() {
      getClubList().then(res => {
        this.clubs = [];
        this.countClub = res.length;
        this.clubs.push(...res);
      });
    },
    SelectClub(item) {
      let times = new Date();
      let createDate = times.getFullYear() + '-' + (times.getMonth() + 1) + '-' + times.getDate() + '-' + times.getHours() + '-' + times.getMinutes() + '-' + times.getSeconds() + ':' + times.getTime();
      if (parseInt(item.startTime) > new Date().getTime()) {
        Toast.fail('未到选择时间');
        return;
      }
      Dialog.confirm({
        title: '提示',
        message: item.title + '确定要选择吗？如果已经选择俱乐部，将会切换俱乐部，时长和训练记录保存不变但俱乐部等级会重置'
      }).then(() => {
        SelectClub(item.id).then(res => {
            if (res.selected) {
              Dialog({message: '选择俱乐部成功，俱乐部详情点击 “我的->当前俱乐部”即可查看'});
            } else {
              Toast.fail(res.message);
            }
          }
        ).catch(res => {
          Toast.fail("选择失败");
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    lookClub(id) {
      let club = this.clubs.filter(item => item.id === id)[0];
      // GetClubCountById(id).then(res => {
      //   this.ClubPeopleCount = res;
      // });
      GetClubDetailById(id).then(res => {
        this.description = res.des;
        this.location = res.location;
      })
      this.startTime = club.startTime;
      this.title = club.title;
      this.maxp = club.maxp;
      this.descriptionShow = true;
    },
    onClickLeft() {
      this.$router.replace("/home");
    }
  }
}
</script>

<style scoped>
.home-nav {
  background-color: var(--color-tint);
  color: #fff;
}

.test {
  width: 70%;
  display: flex;

  position: fixed;

  right: 0;

}
</style>
